/* tslint:disable */
import {
  Survey
} from '../index';

declare var Object: any;
export interface PlayerSurveyInterface {
  "rating": number;
  "selectedChoice": any;
  "selectedComment": Array<any>;
  "id"?: any;
  "surveyId"?: any;
  "playerId"?: any;
  "createdAt": Date;
  "updatedAt": Date;
  survey?: Survey;
}

export class PlayerSurvey implements PlayerSurveyInterface {
  "rating": number;
  "selectedChoice": any;
  "selectedComment": Array<any>;
  "id": any;
  "surveyId": any;
  "playerId": any;
  "createdAt": Date;
  "updatedAt": Date;
  survey: Survey;
  constructor(data?: PlayerSurveyInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PlayerSurvey`.
   */
  public static getModelName() {
    return "PlayerSurvey";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PlayerSurvey for dynamic purposes.
  **/
  public static factory(data: PlayerSurveyInterface): PlayerSurvey{
    return new PlayerSurvey(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PlayerSurvey',
      plural: 'PlayerSurveys',
      path: 'PlayerSurveys',
      idName: 'id',
      properties: {
        "rating": {
          name: 'rating',
          type: 'number'
        },
        "selectedChoice": {
          name: 'selectedChoice',
          type: 'any'
        },
        "selectedComment": {
          name: 'selectedComment',
          type: 'Array&lt;any&gt;'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "surveyId": {
          name: 'surveyId',
          type: 'any'
        },
        "playerId": {
          name: 'playerId',
          type: 'any'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        survey: {
          name: 'survey',
          type: 'Survey',
          model: 'Survey',
          relationType: 'belongsTo',
                  keyFrom: 'surveyId',
          keyTo: 'id'
        },
      }
    }
  }
}
